import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Events } from '@ionic/angular';
import { SessionData } from '../../interfaces/session-data';
import { ContractService } from '../contract/contract.service';
// import { PlayerService$ } from '../../modules/player/player.service';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private SESSION_KEY = '_session';

  private _session: SessionData = {
    email: null,
    member: null,
    contract: null,
    primary: true,
    canbeused: false,
    syncdate: null
  };

  private _defaults: SessionData = {
    email: null,
    member: null,
    contract: null,
    primary: true,
    canbeused: false,
    syncdate: null
  };

  constructor(
    public storage: Storage,
    public contractService: ContractService,
    public events: Events,
  ) {

  }

  public load(): Promise<any> {
    return this.storage.get(this.SESSION_KEY).then((val: SessionData) => {
      this._session = val;
      return Promise.resolve(this._session);
      // return this.calculateSelectedJackpot((<any>value).toJSON(), val);
    }).catch(error => {
      // Se eliminan los datos
      return this.setAll(this._defaults).then((val) => {
        this._session = val;
        return Promise.resolve(this._session);
      });
    });
    return null;
  }

  public destroySession() {
    this.setAll(null);
    this._session = this._defaults;
  }

  public setValue(key: string, value: any) {
    this._session[key] = value;
    return this.storage.set(this.SESSION_KEY, this._session);
  }

  public setAll(value: any) {
    return this.storage.set(this.SESSION_KEY, value);
  }

  public getValue(key: string) {
    return this.storage.get(this.SESSION_KEY)
      .then(settings => {
        return settings[key];
      });
  }

  public getAll() {
    return this.storage.get(this.SESSION_KEY)
      .then(settings => {
        return settings;
      });
  }

  public save() {
    return this.setAll(this._session);
  }

  public get allSession(): SessionData {
    return this._session;
  }
}
